import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Register = () => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    gstNumber: "",
  });
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // localStorage.setItem("user", JSON.stringify(user)); // Save user in localStorage (mock database)
    alert("Registration successful! Now login.");
    navigate("/");
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-pastel-blue-100 to-pastel-pink-100 px-4">
      <motion.form
        className="relative bg-white/50 p-6 sm:p-8 shadow-xl rounded-3xl w-full max-w-sm sm:max-w-md lg:max-w-lg border border-white/30"
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h2 className="text-2xl sm:text-3xl font-extrabold mb-4 sm:mb-6 text-center text-gray-800 tracking-wider">
          Get Started
        </h2>

        {/* First Name & Last Name - Same Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <motion.input
            type="text"
            placeholder="First Name"
            className="w-full p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-blue-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
            onChange={(e) => setUser({ ...user, firstName: e.target.value })}
            required
            whileFocus={{ scale: 1.02 }}
          />
          <motion.input
            type="text"
            placeholder="Last Name"
            className="w-full p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-blue-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
            onChange={(e) => setUser({ ...user, lastName: e.target.value })}
            required
            whileFocus={{ scale: 1.02 }}
          />
        </div>

        {/* Email */}
        <motion.input
          type="email"
          placeholder="Email Address"
          className="w-full mt-3 sm:mt-4 p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-blue-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
          onChange={(e) => setUser({ ...user, email: e.target.value })}
          required
          whileFocus={{ scale: 1.02 }}
        />

        {/* Phone */}
        <motion.input
          type="number"
          placeholder="Phone Number"
          className="w-full mt-3 sm:mt-4 p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-blue-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
          onChange={(e) => setUser({ ...user, phone: e.target.value })}
          required
          whileFocus={{ scale: 1.02 }}
        />

        {/* Password */}
        <motion.input
          type="password"
          placeholder="Password"
          className="w-full mt-3 sm:mt-4 p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-pink-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
          onChange={(e) => setUser({ ...user, password: e.target.value })}
          required
          whileFocus={{ scale: 1.02 }}
        />

        {/* Confirm Password */}
        <motion.input
          type="password"
          placeholder="Confirm Password"
          className="w-full mt-3 sm:mt-4 p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-pink-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
          onChange={(e) =>
            setUser({ ...user, confirmPassword: e.target.value })
          }
          required
          whileFocus={{ scale: 1.02 }}
        />

        {/* Company Name & GST - Same Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-3 sm:mt-4">
          <motion.input
            type="text"
            placeholder="Company Name (Optional)"
            className="w-full p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-pink-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
            onChange={(e) => setUser({ ...user, companyName: e.target.value })}
            whileFocus={{ scale: 1.02 }}
          />
          <motion.input
            type="number"
            placeholder="GST Number (Optional)"
            className="w-full p-3 sm:p-4 bg-white/60 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-pastel-pink-300 text-gray-700 placeholder-gray-500 transition-all duration-300 ease-in-out"
            onChange={(e) => setUser({ ...user, gstNumber: e.target.value })}
            whileFocus={{ scale: 1.02 }}
          />
        </div>

        {/* Register Button */}
        <motion.button
          className="w-full bg-gradient-to-r from-pastel-blue-400 to-pastel-pink-400 text-white p-3 sm:p-4 rounded-xl font-bold shadow-md hover:shadow-lg transition-transform duration-300 ease-in-out hover:scale-105 mt-4 sm:mt-6"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Register
        </motion.button>

        {/* Login Redirect */}
        <p className="text-center text-gray-600 mt-4 sm:mt-6 text-sm">
          Already have an account?{" "}
          <span
            className="text-pastel-blue-500 cursor-pointer hover:underline"
            onClick={() => navigate("/")}
          >
            Login here
          </span>
        </p>
      </motion.form>
    </div>
  );
};

export default Register;
